import { Tooltip } from "components";
import { InfoMessage } from 'components';
import { bool } from "prop-types";
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';
import Label from 'components/fieldLabel';

export const contentAdditional = () =>
  [
    {
      label: <Label 
        label="Επιπλέον Δικαιολογητικά"
        asterisk={false}
      />,
      fileCode: 'supAdditionalDocs',
      id: 'supAdditionalDocs',
      multiple: true,
      fileLimit: 10,
      fileAccepts: ['.pdf','.jpeg', '.jpg', '.png'],
    },
  ].filter(item => item);